
import { defineComponent, PropType } from 'vue'

import OrderPoint from '@/modules/CreateOrder/components/OrderPoint/index.vue'
import { ReceiverT } from '@/core/types/common.types'

export default defineComponent({
    components: {
        'order-point': OrderPoint,
    },
    props: {
        receiver: {
            type: Object as PropType<ReceiverT>,
            default: null,
        },
        blocked: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['reset'],
    setup(_, { emit }) {
        const emitReset = () => {
            emit('reset')
        }

        return { emitReset }
    },
})
